import { gql } from '@apollo/client';

export const RdTaxQuestionsFragment = gql`
  fragment RdTaxQuestions on RDTaxQuestions {
    fiscalYearEndsInDec
    monthAndDayOfTaxYearEnd
    furthestVisitedExpense
    hasAnAccountant
    hasClaimedErc
    hasFiledTaxReturn
    hasFiledExtension
    hasFundedResearch
    hasMadeFiveMillion
    hasPayrollEin
    hasTaxableIncome
    hasTaxableIncomeAfterDeduction
    hasW2Employees
    haveBooksFinalized
    howIsYourBusinessEntityTaxed
    isProfitable
    payrollEin
    payrollProviders
    receivedFundingTypes
  }
`;
